import { __decorate, __metadata, __param } from "tslib";
import { fetchEcomSetting } from '@gn-audio/core/api/site-settings/fetch-ecom-setting';
import { fetchPriceDisplaySetting } from '@gn-audio/core/api/site-settings/fetch-price-display-setting';
import { Directive, Inject } from 'angular-ts-decorators';
var PriceDisplayStateDirective = (function () {
    function PriceDisplayStateDirective($element) {
        this.$element = $element;
    }
    PriceDisplayStateDirective.prototype.ngOnInit = function () {
        var _this = this;
        fetchEcomSetting()
            .then(function (ecomSetting) {
            if (!ecomSetting.ecomEnabled) {
                return;
            }
            fetchPriceDisplaySetting()
                .then(function (priceDisplaySetting) {
                var cssClass = (priceDisplaySetting.priceDisplayOption || '').toLowerCase();
                _this.$element.addClass("price-" + cssClass);
            });
        });
    };
    PriceDisplayStateDirective.$inject = ['$element'];
    PriceDisplayStateDirective = __decorate([
        Directive({
            selector: '[priceDisplayState]',
        }),
        __param(0, Inject('$element')),
        __metadata("design:paramtypes", [Object])
    ], PriceDisplayStateDirective);
    return PriceDisplayStateDirective;
}());
export { PriceDisplayStateDirective };
